<template>
    <div class="modal fade" id="uploadVideoDialog" tabindex="-1" aria-labelledby="uploadVideoDialogLabel" aria-hidden="true">
        <div class="modal-dialog modal-fullscreen modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title m-auto" id="uploadVideoDialogLabel">Upload Video</h5>
                    <button type="button" class="btn-close me-md-3 ms-0" data-bs-dismiss="modal" aria-label="Close" :disabled="loading"></button>
                </div>
                <div class="modal-body">
                    <div class="text-center align-self-center">
                        <div class="row">
                            <div v-show="loading" class="col-sm-6 offset-sm-3">
                                <h5>
                                    Your video is being uploaded.<br />
                                    Please stay on this page until the upload is complete.
                                </h5>
                                <div class="m-4">
                                    <div class="progress" role="progressbar"
                                         aria-label="Upload progress"
                                         aria-valuemin="0"
                                         aria-valuemax="100"
                                         :aria-valuenow="progress">
                                        <div class="progress-bar" :style="{ width: progress+'%' }"></div>
                                    </div>
                                    <div class="m-2 text-center">
                                        {{Math.round(progress)}}%
                                    </div>
                                </div>
                            </div>
                            <div v-show="!loading" class="col-sm-6 offset-sm-3">
                                <div v-if="error" class="alert alert-warning m-3">{{ error }}</div>
                                <div class="alert alert-primary m-3">
                                    For the best results, we recommend using your camera app to take a 360 degree video of your vehicle, 
                                    including the interior and exterior. Then, come back here and select your video.
                                </div>
                                <h5>Select your video to upload</h5>
                                <label class="btn btn-primary">
                                    Select Video
                                    <input ref="fileInput" type="file"
                                           accept="video/mp4,video/x-m4v,video/*"
                                           style="display:none"
                                           @change="upload($event)" />
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" @click.prevent="cancel"> Cancel </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        emits: ['cancel', 'submit'],
        props: ['error', 'progress', 'loading'],
        data: function () {
            return {
                dialog: null,
            };
        },
        methods: {
            cancel() {
                this.$emit('cancel');
                this.hide();
                this.$refs.fileInput.value = '';
            },
            hide() {
                this.dialog?.hide();
            },
            show() {
                if (!this.dialog) {
                    this.dialog = bootstrap.Modal.getOrCreateInstance(this.$el);
                }
                this.dialog.show();
            },
            upload(event) {
                this.$emit('submit', event.target.files[0]);
            }
        }
    }
</script>